import {
  getPromotionTypeOptions,
  getProfileTypeOptions,
  getTemplateScopeOptions,
} from "./constLabels";

/**
 * 案件関連のラベル取得関数を提供する
 */
export const getPromotionLabels = () => {
  const promotionTypes = getPromotionTypeOptions();
  const profileTypes = getProfileTypeOptions();
  const templateScopes = getTemplateScopeOptions();

  const getTypeLabel = (type: string) =>
    promotionTypes.find((pt) => pt.value === type)?.label ?? type;

  const getProfileLabel = (profile: string) =>
    profileTypes.find((pt) => pt.value === profile)?.label ?? profile;

  const getTemplateScopeLabel = (scope: string) =>
    templateScopes.find((ts) => ts.value === scope)?.label ?? scope;

  return {
    getTypeLabel,
    getProfileLabel,
    getTemplateScopeLabel,
  };
};
